import { StyledTimeSheetCalendar } from ".";
import { Calendar, momentLocalizer, View, DateLocalizer } from "react-big-calendar";
import moment from "moment";
import React, { Children, cloneElement, FC, useEffect, useMemo, useState } from "react";
import { Avatar, Box } from "@mui/material";
import { StyledEventContent } from ".";
import { getMonthMoment, linkImage, theme } from "@utils";
import clsx from "clsx";
import { selectAuth, useAppSelector } from "@redux";
import { holidayApi } from "src/Api/holiday";

const localizer = momentLocalizer(moment);

interface IProps {
  timeSheetData?: any;
  handleOpenModal: (date: any, id: any) => void;
  handleOpenModalId: (date: any, id: any, groupId: any) => void;
  handleCloseToggle: (date: any, id: any) => void;
  month?: any;
  onMonthChange?: (newMonth: string) => void;
}
// const TouchCellWrapper = ({ children, value, onSelectSlot, onSelectEvent }) =>
//     cloneElement(Children.only(children), {
//         onClickCapture: (e) => {
//             e.stopPropagation();
//             e.preventDefault();
//             onSelectSlot({ action: "click", slots: [value] });
//             onSelectEvent({ action: "click", slots: [value] });
//         },
//         style: {
//             className: `${children}`,
//         },
//     });
const TouchCellWrapper = ({ children, value, onSelectSlot, onSelectEvent }) => {
  let startX = 0;
  let startY = 0;

  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  };

  const handleTouchMove = (e) => {
    const deltaX = Math.abs(e.touches[0].clientX - startX);
    const deltaY = Math.abs(e.touches[0].clientY - startY);

    if (deltaY > deltaX) {
      e.stopPropagation();
    }
  };

  return cloneElement(Children.only(children), {
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onClick: () => {
      onSelectSlot({ action: "click", slots: [value] });
      onSelectEvent({ action: "click", slots: [value] });
    },
    style: {
      className: `${children}`,
    },
  });
};

export const TimeSheetCalendarComponent = React.memo((props: IProps) => {
  const [getId, setGetId] = useState<any>();
  const [groupId, setGroupId] = useState<any>();
  const { timeSheetData, handleOpenModal, month, handleOpenModalId, onMonthChange } = props;
  const [selectedEvent, setSelectedEvent] = useState<any>();
  const [calendarView, setCalendarView] = useState<View>(window.innerWidth < 768 ? "agenda" : "month");
  const [holidays, setHolidays] = useState<string[]>([]);
  const currentDate = useMemo(() => new Date(`${month}-01`), [month]);

  const handleNavigate = (newDate) => {
    const newMonth = newDate.toISOString().slice(0, 7);
    if (onMonthChange) {
      onMonthChange(newMonth);
    }
  };

  const fetchHoliday = async () => {
    try {
      const res = await holidayApi.getMonthHolidays({
        year: parseInt(month.slice(0, 4)),
        month: parseInt(month.slice(5, 7)),
        page_key: "timesheet"
      });
      const holidayDates = res.data.data.date_holiday.map((d) => d.date);
      setHolidays(holidayDates);
    } catch (error) {
      console.error("休日情報取得失敗", error);
    }
  };

  useEffect(() => {
    fetchHoliday();
  }, [month]);

  useEffect(() => {
    const handleResize = () => {
      setCalendarView(window.innerWidth < 768 ? "agenda" : "month");
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (selectedEvent) {
      handleOpenModalId(
        {
          startDate: selectedEvent.startDate,
        },
        getId,
        groupId
      );
    }
  }, [selectedEvent]);

  const CustomAgendaDateCell = ({ day, label }: any) => {
    const dateStr = moment(day).format("YYYY-MM-DD");
    const isHoliday = holidays.includes(dateStr);

    return (
      <div className={isHoliday ? "rbc-agenda-date-cell holiday-bg" : "rbc-agenda-date-cell"}>
        {label}
      </div>
    );
  };


  const onSelectEvent = (event, id) => {
    if (getMonthMoment(event.startDate) === getMonthMoment(moment(month).format("YYYY-MM-DD"))) setSelectedEvent({ ...event, id });
  };
  const onSelectSlot = ({ action, slots }) => {
    if (action === "click") {
      setGetId("");
      setGroupId("");
    }
    return false;
  };

  const CustomDateCellWrapper = (props) => {
    const { value, children, ...rest } = props;

    const dateStr = moment(value).format("YYYY-MM-DD");
    const isHoliday = holidays.includes(dateStr);

    return (
      <div className={isHoliday ? "rbc-day-bg holiday-bg" : "rbc-day-bg"}
        style={{ height: "100%" }}>
        <TouchCellWrapper
          {...rest}
          value={value}
          onSelectSlot={onSelectSlot}
          onSelectEvent={(e) => onSelectEvent(e, getId)}
        >
          {children}
        </TouchCellWrapper>
      </div>
    );
  };

  const Event = (event: any) => {
    const ref = React.useRef(null);
    const auth = useAppSelector(selectAuth);
    const userInfo = auth.userInfo;

    const handleClick = (event) => {
      const userId = event.currentTarget.dataset.userId;

      setGetId(userId);
    };
    return (
      <Box sx={{ width: "100%", height: "100%" }} ref={ref}>
        <StyledEventContent>
          <div className="groupUser">
            <div className="user">
              {event.event?.users &&
                event.event?.users?.map((user) =>
                  user.timesheets?.length ? (
                    <div key={user.id} className={clsx(user.id === userInfo?.id ? "mine" : "", "wrapperAvatar")} onClick={handleClick} data-user-id={user.id}>
                      <div className="content">
                        <Avatar src={linkImage(user?.avatar?.path)} alt="avatar" />
                        <span className="name">
                          {user?.last_name}
                          {user?.first_name}
                        </span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                )}
            </div>
          </div>
        </StyledEventContent>
      </Box>
    );
  };
  return (
    <StyledTimeSheetCalendar>
      <Calendar
        localizer={localizer as DateLocalizer}
        events={[...timeSheetData]}
        startAccessor="startDate"
        endAccessor="endDate"
        defaultDate={new Date(`${month}-01`)}
        // date={new Date(`${month}-01`)}
        date={currentDate}
        onNavigate={handleNavigate}
        components={{
          event: Event,
          dateCellWrapper: CustomDateCellWrapper,
          // dateCellWrapper: (props) => (
          //   <TouchCellWrapper
          //     children="selectable"
          //     value={undefined}
          //     {...props}
          //     onSelectSlot={onSelectSlot}
          //     onSelectEvent={(e) => onSelectEvent(e, getId)}
          //   />
          // ),
          agenda: {
            time: () => null,
            date: CustomAgendaDateCell
          },
        }}
        formats={{
          agendaDateFormat: (date, culture, localizer) =>
            localizer!.format(date, "ddd DD", culture),
        }}
        selectable={true}
        onSelectSlot={onSelectSlot}
        onSelectEvent={(e) => onSelectEvent(e, getId)}
        view={calendarView}
        views={["month", "agenda"]}
        longPressThreshold={250}
      />
    </StyledTimeSheetCalendar>
  );
});

// function Event(event: any) {
//     const ref = React.useRef(null);
//     const auth = useAppSelector(selectAuth);
//     const userInfo = auth.userInfo;
//     function handleClick(event) {
//         const userId = event.currentTarget.dataset.userId;
//         setGetId(userId);
//       }

//     return (
//         <Box sx={{ width: "100%", height: "100%" }} ref={ref}>
//             <StyledEventContent>
//                 <div className="groupUser">
//                     <div className="user">
//                         {event.event?.users &&
//                             getFirstOfListUsersTimeSheet(event.event?.users, 4)?.map((user) =>
//                                 user.timesheets?.length ? (
//                                     <div
//                                         key={user.id}
//                                         className={clsx(
//                                             user.id === userInfo?.id ? "mine" : "",
//                                             "wrapperAvatar"
//                                         )}
//                                         onClick={handleClick}
//                                         data-user-id={user.id}
//                                     >
//                                         <div className="content">
//                                             <Avatar
//                                                 src={linkImage(user?.avatar?.path)}
//                                                 alt="avatar"
//                                             />
//                                             <span className="name">
//                                                 {user?.last_name}
//                                                 {user?.first_name}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     ""
//                                 )
//                             )}
//                         {event.event?.users?.length > 4 && (
//                             <div className="more__dot">
//                                 <span className="mobile__dot">...</span>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </StyledEventContent>
//         </Box>
//     );
// };
